/***************************************************************************
 * The contents of this file were generated with Amplify Studio.           *
 * Please refrain from making any modifications to this file.              *
 * Any changes to this file will be overwritten when running amplify pull. *
 **************************************************************************/

/* eslint-disable */
import * as React from "react";
import {
  Autocomplete,
  Badge,
  Button,
  Divider,
  Flex,
  Grid,
  Icon,
  ScrollView,
  SelectField,
  Text,
  TextAreaField,
  TextField,
  useTheme,
} from "@aws-amplify/ui-react";
import { fetchByPath, getOverrideProps, validateField } from "./utils";
import { generateClient } from "aws-amplify/api";
import { listTestExecutions } from "../graphql/queries";
import { createTest, updateTestExecution } from "../graphql/mutations";
const client = generateClient();
function ArrayField({
  items = [],
  onChange,
  label,
  inputFieldRef,
  children,
  hasError,
  setFieldValue,
  currentFieldValue,
  defaultFieldValue,
  lengthLimit,
  getBadgeText,
  runValidationTasks,
  errorMessage,
}) {
  const labelElement = <Text>{label}</Text>;
  const {
    tokens: {
      components: {
        fieldmessages: { error: errorStyles },
      },
    },
  } = useTheme();
  const [selectedBadgeIndex, setSelectedBadgeIndex] = React.useState();
  const [isEditing, setIsEditing] = React.useState();
  React.useEffect(() => {
    if (isEditing) {
      inputFieldRef?.current?.focus();
    }
  }, [isEditing]);
  const removeItem = async (removeIndex) => {
    const newItems = items.filter((value, index) => index !== removeIndex);
    await onChange(newItems);
    setSelectedBadgeIndex(undefined);
  };
  const addItem = async () => {
    const { hasError } = runValidationTasks();
    if (
      currentFieldValue !== undefined &&
      currentFieldValue !== null &&
      currentFieldValue !== "" &&
      !hasError
    ) {
      const newItems = [...items];
      if (selectedBadgeIndex !== undefined) {
        newItems[selectedBadgeIndex] = currentFieldValue;
        setSelectedBadgeIndex(undefined);
      } else {
        newItems.push(currentFieldValue);
      }
      await onChange(newItems);
      setIsEditing(false);
    }
  };
  const arraySection = (
    <React.Fragment>
      {!!items?.length && (
        <ScrollView height="inherit" width="inherit" maxHeight={"7rem"}>
          {items.map((value, index) => {
            return (
              <Badge
                key={index}
                style={{
                  cursor: "pointer",
                  alignItems: "center",
                  marginRight: 3,
                  marginTop: 3,
                  backgroundColor:
                    index === selectedBadgeIndex ? "#B8CEF9" : "",
                }}
                onClick={() => {
                  setSelectedBadgeIndex(index);
                  setFieldValue(items[index]);
                  setIsEditing(true);
                }}
              >
                {getBadgeText ? getBadgeText(value) : value.toString()}
                <Icon
                  style={{
                    cursor: "pointer",
                    paddingLeft: 3,
                    width: 20,
                    height: 20,
                  }}
                  viewBox={{ width: 20, height: 20 }}
                  paths={[
                    {
                      d: "M10 10l5.09-5.09L10 10l5.09 5.09L10 10zm0 0L4.91 4.91 10 10l-5.09 5.09L10 10z",
                      stroke: "black",
                    },
                  ]}
                  ariaLabel="button"
                  onClick={(event) => {
                    event.stopPropagation();
                    removeItem(index);
                  }}
                />
              </Badge>
            );
          })}
        </ScrollView>
      )}
      <Divider orientation="horizontal" marginTop={5} />
    </React.Fragment>
  );
  if (lengthLimit !== undefined && items.length >= lengthLimit && !isEditing) {
    return (
      <React.Fragment>
        {labelElement}
        {arraySection}
      </React.Fragment>
    );
  }
  return (
    <React.Fragment>
      {labelElement}
      {isEditing && children}
      {!isEditing ? (
        <>
          <Button
            onClick={() => {
              setIsEditing(true);
            }}
          >
            Add item
          </Button>
          {errorMessage && hasError && (
            <Text color={errorStyles.color} fontSize={errorStyles.fontSize}>
              {errorMessage}
            </Text>
          )}
        </>
      ) : (
        <Flex justifyContent="flex-end">
          {(currentFieldValue || isEditing) && (
            <Button
              children="Cancel"
              type="button"
              size="small"
              onClick={() => {
                setFieldValue(defaultFieldValue);
                setIsEditing(false);
                setSelectedBadgeIndex(undefined);
              }}
            ></Button>
          )}
          <Button size="small" variation="link" onClick={addItem}>
            {selectedBadgeIndex !== undefined ? "Save" : "Add"}
          </Button>
        </Flex>
      )}
      {arraySection}
    </React.Fragment>
  );
}
export default function TestCreateForm(props) {
  const {
    clearOnSuccess = true,
    onSuccess,
    onError,
    onSubmit,
    onValidate,
    onChange,
    overrides,
    ...rest
  } = props;
  const initialValues = {
    Topic: "",
    Grade: "",
    Type: "",
    name: "",
    questions: [],
    durationInMinutes: "",
    numberOfQuestions: "",
    TestExecutions: [],
  };
  const [Topic, setTopic] = React.useState(initialValues.Topic);
  const [Grade, setGrade] = React.useState(initialValues.Grade);
  const [Type, setType] = React.useState(initialValues.Type);
  const [name, setName] = React.useState(initialValues.name);
  const [questions, setQuestions] = React.useState(initialValues.questions);
  const [durationInMinutes, setDurationInMinutes] = React.useState(
    initialValues.durationInMinutes
  );
  const [numberOfQuestions, setNumberOfQuestions] = React.useState(
    initialValues.numberOfQuestions
  );
  const [TestExecutions, setTestExecutions] = React.useState(
    initialValues.TestExecutions
  );
  const [TestExecutionsLoading, setTestExecutionsLoading] =
    React.useState(false);
  const [testExecutionsRecords, setTestExecutionsRecords] = React.useState([]);
  const autocompleteLength = 10;
  const [errors, setErrors] = React.useState({});
  const resetStateValues = () => {
    setTopic(initialValues.Topic);
    setGrade(initialValues.Grade);
    setType(initialValues.Type);
    setName(initialValues.name);
    setQuestions(initialValues.questions);
    setCurrentQuestionsValue("");
    setDurationInMinutes(initialValues.durationInMinutes);
    setNumberOfQuestions(initialValues.numberOfQuestions);
    setTestExecutions(initialValues.TestExecutions);
    setCurrentTestExecutionsValue(undefined);
    setCurrentTestExecutionsDisplayValue("");
    setErrors({});
  };
  const [currentQuestionsValue, setCurrentQuestionsValue] = React.useState("");
  const questionsRef = React.createRef();
  const [
    currentTestExecutionsDisplayValue,
    setCurrentTestExecutionsDisplayValue,
  ] = React.useState("");
  const [currentTestExecutionsValue, setCurrentTestExecutionsValue] =
    React.useState(undefined);
  const TestExecutionsRef = React.createRef();
  const getIDValue = {
    TestExecutions: (r) => JSON.stringify({ id: r?.id }),
  };
  const TestExecutionsIdSet = new Set(
    Array.isArray(TestExecutions)
      ? TestExecutions.map((r) => getIDValue.TestExecutions?.(r))
      : getIDValue.TestExecutions?.(TestExecutions)
  );
  const getDisplayValue = {
    TestExecutions: (r) => `${r?.score ? r?.score + " - " : ""}${r?.id}`,
  };
  const validations = {
    Topic: [],
    Grade: [],
    Type: [],
    name: [],
    questions: [{ type: "Required" }, { type: "JSON" }],
    durationInMinutes: [],
    numberOfQuestions: [],
    TestExecutions: [],
  };
  const runValidationTasks = async (
    fieldName,
    currentValue,
    getDisplayValue
  ) => {
    const value =
      currentValue && getDisplayValue
        ? getDisplayValue(currentValue)
        : currentValue;
    let validationResponse = validateField(value, validations[fieldName]);
    const customValidator = fetchByPath(onValidate, fieldName);
    if (customValidator) {
      validationResponse = await customValidator(value, validationResponse);
    }
    setErrors((errors) => ({ ...errors, [fieldName]: validationResponse }));
    return validationResponse;
  };
  const fetchTestExecutionsRecords = async (value) => {
    setTestExecutionsLoading(true);
    const newOptions = [];
    let newNext = "";
    while (newOptions.length < autocompleteLength && newNext != null) {
      const variables = {
        limit: autocompleteLength * 5,
        filter: {
          or: [{ score: { contains: value } }, { id: { contains: value } }],
        },
      };
      if (newNext) {
        variables["nextToken"] = newNext;
      }
      const result = (
        await client.graphql({
          query: listTestExecutions.replaceAll("__typename", ""),
          variables,
        })
      )?.data?.listTestExecutions?.items;
      var loaded = result.filter(
        (item) => !TestExecutionsIdSet.has(getIDValue.TestExecutions?.(item))
      );
      newOptions.push(...loaded);
      newNext = result.nextToken;
    }
    setTestExecutionsRecords(newOptions.slice(0, autocompleteLength));
    setTestExecutionsLoading(false);
  };
  React.useEffect(() => {
    fetchTestExecutionsRecords("");
  }, []);
  return (
    <Grid
      as="form"
      rowGap="15px"
      columnGap="15px"
      padding="20px"
      onSubmit={async (event) => {
        event.preventDefault();
        let modelFields = {
          Topic,
          Grade,
          Type,
          name,
          questions,
          durationInMinutes,
          numberOfQuestions,
          TestExecutions,
        };
        const validationResponses = await Promise.all(
          Object.keys(validations).reduce((promises, fieldName) => {
            if (Array.isArray(modelFields[fieldName])) {
              promises.push(
                ...modelFields[fieldName].map((item) =>
                  runValidationTasks(
                    fieldName,
                    item,
                    getDisplayValue[fieldName]
                  )
                )
              );
              return promises;
            }
            promises.push(
              runValidationTasks(
                fieldName,
                modelFields[fieldName],
                getDisplayValue[fieldName]
              )
            );
            return promises;
          }, [])
        );
        if (validationResponses.some((r) => r.hasError)) {
          return;
        }
        if (onSubmit) {
          modelFields = onSubmit(modelFields);
        }
        try {
          Object.entries(modelFields).forEach(([key, value]) => {
            if (typeof value === "string" && value === "") {
              modelFields[key] = null;
            }
          });
          const modelFieldsToSave = {
            Topic: modelFields.Topic,
            Grade: modelFields.Grade,
            Type: modelFields.Type,
            name: modelFields.name,
            durationInMinutes: modelFields.durationInMinutes,
            numberOfQuestions: modelFields.numberOfQuestions,
            questions: modelFields.questions.map((s) => JSON.parse(s)),
          };
          const test = (
            await client.graphql({
              query: createTest.replaceAll("__typename", ""),
              variables: {
                input: {
                  ...modelFieldsToSave,
                },
              },
            })
          )?.data?.createTest;
          const promises = [];
          promises.push(
            ...TestExecutions.reduce((promises, original) => {
              promises.push(
                client.graphql({
                  query: updateTestExecution.replaceAll("__typename", ""),
                  variables: {
                    input: {
                      id: original.id,
                      testID: test.id,
                    },
                  },
                })
              );
              return promises;
            }, [])
          );
          await Promise.all(promises);
          if (onSuccess) {
            onSuccess(modelFields);
          }
          if (clearOnSuccess) {
            resetStateValues();
          }
        } catch (err) {
          if (onError) {
            const messages = err.errors.map((e) => e.message).join("\n");
            onError(modelFields, messages);
          }
        }
      }}
      {...getOverrideProps(overrides, "TestCreateForm")}
      {...rest}
    >
      <TextField
        label="Topic"
        isRequired={false}
        isReadOnly={false}
        value={Topic}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              Topic: value,
              Grade,
              Type,
              name,
              questions,
              durationInMinutes,
              numberOfQuestions,
              TestExecutions,
            };
            const result = onChange(modelFields);
            value = result?.Topic ?? value;
          }
          if (errors.Topic?.hasError) {
            runValidationTasks("Topic", value);
          }
          setTopic(value);
        }}
        onBlur={() => runValidationTasks("Topic", Topic)}
        errorMessage={errors.Topic?.errorMessage}
        hasError={errors.Topic?.hasError}
        {...getOverrideProps(overrides, "Topic")}
      ></TextField>
      <TextField
        label="Grade"
        isRequired={false}
        isReadOnly={false}
        value={Grade}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              Topic,
              Grade: value,
              Type,
              name,
              questions,
              durationInMinutes,
              numberOfQuestions,
              TestExecutions,
            };
            const result = onChange(modelFields);
            value = result?.Grade ?? value;
          }
          if (errors.Grade?.hasError) {
            runValidationTasks("Grade", value);
          }
          setGrade(value);
        }}
        onBlur={() => runValidationTasks("Grade", Grade)}
        errorMessage={errors.Grade?.errorMessage}
        hasError={errors.Grade?.hasError}
        {...getOverrideProps(overrides, "Grade")}
      ></TextField>
      <SelectField
        label="Type"
        placeholder="Please select an option"
        isDisabled={false}
        value={Type}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              Topic,
              Grade,
              Type: value,
              name,
              questions,
              durationInMinutes,
              numberOfQuestions,
              TestExecutions,
            };
            const result = onChange(modelFields);
            value = result?.Type ?? value;
          }
          if (errors.Type?.hasError) {
            runValidationTasks("Type", value);
          }
          setType(value);
        }}
        onBlur={() => runValidationTasks("Type", Type)}
        errorMessage={errors.Type?.errorMessage}
        hasError={errors.Type?.hasError}
        {...getOverrideProps(overrides, "Type")}
      >
        <option
          children="Practice"
          value="PRACTICE"
          {...getOverrideProps(overrides, "Typeoption0")}
        ></option>
        <option
          children="Evaluation"
          value="EVALUATION"
          {...getOverrideProps(overrides, "Typeoption1")}
        ></option>
        <option
          children="Final"
          value="FINAL"
          {...getOverrideProps(overrides, "Typeoption2")}
        ></option>
      </SelectField>
      <TextField
        label="Name"
        isRequired={false}
        isReadOnly={false}
        value={name}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              Topic,
              Grade,
              Type,
              name: value,
              questions,
              durationInMinutes,
              numberOfQuestions,
              TestExecutions,
            };
            const result = onChange(modelFields);
            value = result?.name ?? value;
          }
          if (errors.name?.hasError) {
            runValidationTasks("name", value);
          }
          setName(value);
        }}
        onBlur={() => runValidationTasks("name", name)}
        errorMessage={errors.name?.errorMessage}
        hasError={errors.name?.hasError}
        {...getOverrideProps(overrides, "name")}
      ></TextField>
      <ArrayField
        onChange={async (items) => {
          let values = items;
          if (onChange) {
            const modelFields = {
              Topic,
              Grade,
              Type,
              name,
              questions: values,
              durationInMinutes,
              numberOfQuestions,
              TestExecutions,
            };
            const result = onChange(modelFields);
            values = result?.questions ?? values;
          }
          setQuestions(values);
          setCurrentQuestionsValue("");
        }}
        currentFieldValue={currentQuestionsValue}
        label={"Questions"}
        items={questions}
        hasError={errors?.questions?.hasError}
        runValidationTasks={async () =>
          await runValidationTasks("questions", currentQuestionsValue)
        }
        errorMessage={errors?.questions?.errorMessage}
        setFieldValue={setCurrentQuestionsValue}
        inputFieldRef={questionsRef}
        defaultFieldValue={""}
      >
        <TextAreaField
          label="Questions"
          isRequired={true}
          isReadOnly={false}
          value={currentQuestionsValue}
          onChange={(e) => {
            let { value } = e.target;
            if (errors.questions?.hasError) {
              runValidationTasks("questions", value);
            }
            setCurrentQuestionsValue(value);
          }}
          onBlur={() => runValidationTasks("questions", currentQuestionsValue)}
          errorMessage={errors.questions?.errorMessage}
          hasError={errors.questions?.hasError}
          ref={questionsRef}
          labelHidden={true}
          {...getOverrideProps(overrides, "questions")}
        ></TextAreaField>
      </ArrayField>
      <TextField
        label="Duration in minutes"
        isRequired={false}
        isReadOnly={false}
        type="number"
        step="any"
        value={durationInMinutes}
        onChange={(e) => {
          let value = isNaN(parseInt(e.target.value))
            ? e.target.value
            : parseInt(e.target.value);
          if (onChange) {
            const modelFields = {
              Topic,
              Grade,
              Type,
              name,
              questions,
              durationInMinutes: value,
              numberOfQuestions,
              TestExecutions,
            };
            const result = onChange(modelFields);
            value = result?.durationInMinutes ?? value;
          }
          if (errors.durationInMinutes?.hasError) {
            runValidationTasks("durationInMinutes", value);
          }
          setDurationInMinutes(value);
        }}
        onBlur={() =>
          runValidationTasks("durationInMinutes", durationInMinutes)
        }
        errorMessage={errors.durationInMinutes?.errorMessage}
        hasError={errors.durationInMinutes?.hasError}
        {...getOverrideProps(overrides, "durationInMinutes")}
      ></TextField>
      <TextField
        label="Number of questions"
        isRequired={false}
        isReadOnly={false}
        type="number"
        step="any"
        value={numberOfQuestions}
        onChange={(e) => {
          let value = isNaN(parseInt(e.target.value))
            ? e.target.value
            : parseInt(e.target.value);
          if (onChange) {
            const modelFields = {
              Topic,
              Grade,
              Type,
              name,
              questions,
              durationInMinutes,
              numberOfQuestions: value,
              TestExecutions,
            };
            const result = onChange(modelFields);
            value = result?.numberOfQuestions ?? value;
          }
          if (errors.numberOfQuestions?.hasError) {
            runValidationTasks("numberOfQuestions", value);
          }
          setNumberOfQuestions(value);
        }}
        onBlur={() =>
          runValidationTasks("numberOfQuestions", numberOfQuestions)
        }
        errorMessage={errors.numberOfQuestions?.errorMessage}
        hasError={errors.numberOfQuestions?.hasError}
        {...getOverrideProps(overrides, "numberOfQuestions")}
      ></TextField>
      <ArrayField
        onChange={async (items) => {
          let values = items;
          if (onChange) {
            const modelFields = {
              Topic,
              Grade,
              Type,
              name,
              questions,
              durationInMinutes,
              numberOfQuestions,
              TestExecutions: values,
            };
            const result = onChange(modelFields);
            values = result?.TestExecutions ?? values;
          }
          setTestExecutions(values);
          setCurrentTestExecutionsValue(undefined);
          setCurrentTestExecutionsDisplayValue("");
        }}
        currentFieldValue={currentTestExecutionsValue}
        label={"Test executions"}
        items={TestExecutions}
        hasError={errors?.TestExecutions?.hasError}
        runValidationTasks={async () =>
          await runValidationTasks("TestExecutions", currentTestExecutionsValue)
        }
        errorMessage={errors?.TestExecutions?.errorMessage}
        getBadgeText={getDisplayValue.TestExecutions}
        setFieldValue={(model) => {
          setCurrentTestExecutionsDisplayValue(
            model ? getDisplayValue.TestExecutions(model) : ""
          );
          setCurrentTestExecutionsValue(model);
        }}
        inputFieldRef={TestExecutionsRef}
        defaultFieldValue={""}
      >
        <Autocomplete
          label="Test executions"
          isRequired={false}
          isReadOnly={false}
          placeholder="Search TestExecution"
          value={currentTestExecutionsDisplayValue}
          options={testExecutionsRecords
            .filter(
              (r) => !TestExecutionsIdSet.has(getIDValue.TestExecutions?.(r))
            )
            .map((r) => ({
              id: getIDValue.TestExecutions?.(r),
              label: getDisplayValue.TestExecutions?.(r),
            }))}
          isLoading={TestExecutionsLoading}
          onSelect={({ id, label }) => {
            setCurrentTestExecutionsValue(
              testExecutionsRecords.find((r) =>
                Object.entries(JSON.parse(id)).every(
                  ([key, value]) => r[key] === value
                )
              )
            );
            setCurrentTestExecutionsDisplayValue(label);
            runValidationTasks("TestExecutions", label);
          }}
          onClear={() => {
            setCurrentTestExecutionsDisplayValue("");
          }}
          onChange={(e) => {
            let { value } = e.target;
            fetchTestExecutionsRecords(value);
            if (errors.TestExecutions?.hasError) {
              runValidationTasks("TestExecutions", value);
            }
            setCurrentTestExecutionsDisplayValue(value);
            setCurrentTestExecutionsValue(undefined);
          }}
          onBlur={() =>
            runValidationTasks(
              "TestExecutions",
              currentTestExecutionsDisplayValue
            )
          }
          errorMessage={errors.TestExecutions?.errorMessage}
          hasError={errors.TestExecutions?.hasError}
          ref={TestExecutionsRef}
          labelHidden={true}
          {...getOverrideProps(overrides, "TestExecutions")}
        ></Autocomplete>
      </ArrayField>
      <Flex
        justifyContent="space-between"
        {...getOverrideProps(overrides, "CTAFlex")}
      >
        <Button
          children="Clear"
          type="reset"
          onClick={(event) => {
            event.preventDefault();
            resetStateValues();
          }}
          {...getOverrideProps(overrides, "ClearButton")}
        ></Button>
        <Flex
          gap="15px"
          {...getOverrideProps(overrides, "RightAlignCTASubFlex")}
        >
          <Button
            children="Submit"
            type="submit"
            variation="primary"
            isDisabled={Object.values(errors).some((e) => e?.hasError)}
            {...getOverrideProps(overrides, "SubmitButton")}
          ></Button>
        </Flex>
      </Flex>
    </Grid>
  );
}
